export const MENU = [
  {
    key: 'patient',
    label: 'Patient Management',
    order: 1,
  },
  {
    key: 'brandSwap',
    label: 'Brand Swap',
    order: 2,
  },
  {
    key: 'printFoil',
    label: 'Pack Creator',
    order: 3,
  },
  {
    key: 'job',
    label: 'Pack Management',
    order: 4,
  },
  {
    key: 'vpb',
    label: 'Virtual Pill Balance',
    order: 5,
  },
  {
    key: 'qscript',
    label: 'QScript',
    order: 6,
  },
  {
    key: 'dispenseTracker',
    label: 'Dispense Tracker',
    order: 7,
  },
  {
    key: 'report',
    label: 'Reporting',
    order: 8,
  },
  {
    key: 'signing-sheets',
    label: 'Signing Sheet',
    order: 9,
  },
  {
    key: 'patientGroup',
    label: 'Patient Group',
    order: 10,
  },
  {
    key: 'drug',
    label: 'Drugs',
    order: 11,
  },
  {
    key: 'doctor',
    label: 'Doctors',
    order: 12,
  },
  {
    key: 'direction',
    label: 'Directions',
    order: 13,
  },
  {
    key: 'printProfile',
    label: 'Print Options',
    order: 14,
  },
  {
    key: 'role',
    label: 'Roles',
    order: 15,
  },
  {
    key: 'user',
    label: 'User',
    order: 16,
  },
  {
    key: 'pharmacy',
    label: 'Pharmacy',
    order: 17,
  },
];

export const MENU_ENUM = {
  HOME: 'home',
  PATIENT: 'patient',
  DRUG: 'drug',
  PATIENT_GROUP: 'patientGroup',
  DOCTOR: 'doctor',
  DIRECTION: 'direction',
  PRINT_FOIL: 'printFoil',
  REPORT: 'report',
  SIGNING_SHEETS: 'signing-sheets',
  PRINT_PROFILE: 'printProfile',
  ROLE: 'role',
  USER: 'user',
  BRAND_SWAP: 'brandSwap',
  PHARMACY: 'pharmacy',
  ANNOUNCEMENT: 'announcement',
  JOB: 'job',
  VPB: 'vpb',
  DISPENSE_TRACKER: 'dispenseTracker',
  // SYNC: 'sync',
  FEEDBACK: 'Feed Back',
};

export const PHASE_ENUM = [
  { key: 'PRINTING', label: 'Printing Phase', order: 1 },
  { key: 'PACKING', label: 'Packing Phase', order: 2 },
  { key: 'CHECKING', label: 'Checking Phase', order: 3 },
  { key: 'DISTRIBUTION', label: 'Distribution Phase', order: 4 },
  { key: 'COMPLETED', label: 'Completed Phase', order: 5 },
];

export const JOB_MANAGERMENT_ENUM = [
  {
    key: 'printingPrintAndPack',
    label: 'Print and Pack',
    group: PHASE_ENUM[0].label,
    order: PHASE_ENUM[0].order,
  },
  {
    key: 'printingRobotPack',
    label: 'Robot Pack',
    group: PHASE_ENUM[0].label,
    order: PHASE_ENUM[0].order,
  },
  {
    key: 'printingDeletePack',
    label: 'Delete Pack',
    group: PHASE_ENUM[0].label,
    order: PHASE_ENUM[0].order,
  },
  {
    key: 'packingCompletePack',
    label: 'Complete Pack',
    group: PHASE_ENUM[1].label,
    order: PHASE_ENUM[1].order,
  },
  {
    key: 'packingPackCorrection',
    label: 'Pack Correction',
    group: PHASE_ENUM[1].label,
    order: PHASE_ENUM[1].order,
  },
  {
    key: 'packingDeletePack',
    label: 'Delete Pack',
    group: PHASE_ENUM[1].label,
    order: PHASE_ENUM[1].order,
  },
  {
    key: 'checkingConfirmPass',
    label: 'Confirm Pass',
    group: PHASE_ENUM[2].label,
    order: PHASE_ENUM[2].order,
  },
  {
    key: 'checkingPackCorrection',
    label: 'Pack Correction',
    group: PHASE_ENUM[2].label,
    order: PHASE_ENUM[2].order,
  },
  {
    key: 'checkingDeletePack',
    label: 'Delete Pack',
    group: PHASE_ENUM[2].label,
    order: PHASE_ENUM[2].order,
  },
  {
    key: 'distributionCompletePack',
    label: 'Complete Pack',
    group: PHASE_ENUM[3].label,
    order: PHASE_ENUM[3].order,
  },
  {
    key: 'distributionDeletePack',
    label: 'Delete Pack',
    group: PHASE_ENUM[3].label,
    order: PHASE_ENUM[3].order,
  },
  {
    key: 'completedRevertToDistribution',
    label: 'Revert Pack back to Distribution',
    group: PHASE_ENUM[4].label,
    order: PHASE_ENUM[4].order,
  },
  {
    key: 'completedDeletePack',
    label: 'Delete Pack',
    group: PHASE_ENUM[4].label,
    order: PHASE_ENUM[4].order,
  },
];

export const USER_MANAGEMENT_ENUM = [
  {
    key: 'userAddUser',
    label: 'Add User',
    group: 'User Management',
    order: 1,
  },
  {
    key: 'userEditUser',
    label: 'Edit User',
    group: 'User Management',
    order: 2,
  },
  {
    key: 'userChangePassword',
    label: 'Change User Password',
    group: 'User Management',
    order: 3,
  },
  {
    key: 'userSendResetPassword',
    label: 'Send Reset Password Email',
    group: 'User Management',
    order: 4,
  },
];

export const PHARMACY_MANAGEMENT_ENUM = [
  {
    key: 'pharmacyEditProfile',
    label: 'Edit Pharmacy Profile',
    group: 'Pharmacy Management',
    order: 1,
  },
  {
    key: 'pharmacyEditSettings',
    label: 'Edit Pharmacy Settings',
    group: 'Pharmacy Management',
    order: 2,
  },
];

export const DIRECTIONS_MANAGEMENT_ENUM = [
  {
    key: 'directionsAddNew',
    label: 'Add New Directions',
    group: 'Directions Management',
    order: 1,
  },
  {
    key: 'directionsEdit',
    label: 'Edit Directions',
    group: 'Directions Management',
    order: 2,
  },
];
export const DISPENSE_TRACKER_MANAGEMENT_ENUM = [
  {
    key: 'dispenseTrackerImportMappedScripts',
    label: 'Import Mapped Scripts',
    group: 'Dispense Tracker Management',
    order: 1,
  },
  {
    key: 'dispenseTrackerIgnoreMappedScripts',
    label: 'Ignore Mapped Scripts',
    group: 'Dispense Tracker Management',
    order: 2,
  },
  {
    key: 'dispenseTrackerImportUnmappedScripts',
    label: 'Import Unmapped Scripts',
    group: 'Dispense Tracker Management',
    order: 3,
  },
  {
    key: 'dispenseTrackerIgnoreUnmappedScripts',
    label: 'Ignore Unmapped Scripts',
    group: 'Dispense Tracker Management',
    order: 4,
  },
  {
    key: 'dispenseTrackerMarkIgnoredScriptsAsActive',
    label: 'Mark Ignored Scripts as Active',
    group: 'Dispense Tracker Management',
    order: 5,
  },
];

export const PATIENT_GROUP_MANAGEMENT_ENUM = [
  {
    key: 'patientGroupAdd',
    label: 'Add Patient Group',
    group: 'Patient Group Management',
    order: 1,
  },
  {
    key: 'patientGroupEdit',
    label: 'Edit Patient Group',
    group: 'Patient Group Management',
    order: 2,
  },
  {
    key: 'patientGroupDelete',
    label: 'Delete Patient Group',
    group: 'Patient Group Management',
    order: 3,
  },
  {
    key: 'patientGroupDefaultTimeslots',
    label: 'Default Timeslots',
    group: 'Patient Group Management',
    order: 4,
  },
  {
    key: 'patientGroupEditPackOptions',
    label: 'Edit Pack Options',
    group: 'Patient Group Management',
    order: 5,
  },
];

export const DOCTOR_MANAGEMENT_ENUM = [
  {
    key: 'doctorAdd',
    label: 'Add Doctor',
    group: 'Doctor Management',
    order: 1,
  },
  {
    key: 'doctorEdit',
    label: 'Edit Doctor',
    group: 'Doctor Management',
    order: 2,
  },
  {
    key: 'doctorDelete',
    label: 'Delete Doctor',
    group: 'Doctor Management',
    order: 3,
  },
];

export const REPORT_MANAGEMENT_ENUM = [
  {
    key: 'reportPatientReports',
    label: 'Patient Reports',
    group: 'Report Management',
    order: 1,
  },
  {
    key: 'reportSummaryReports',
    label: 'Summary Reports',
    group: 'Report Management',
    order: 2,
  },
  {
    key: 'reportScriptRequestsReports',
    label: 'Script Requests Reports',
    group: 'Report Management',
    order: 3,
  },
  {
    key: 'reportPpaClaimReports',
    label: 'PPA Claim Reports',
    group: 'Report Management',
    order: 4,
  },
];

export const VPB_MANAGEMENT_ENUM = [
  {
    key: 'vpbInitialPillBalance',
    label: 'Initial Pill Balance',
    group: 'Virtual Pill Balance Management',
    order: 1,
  },
  {
    key: 'vpbForecast',
    label: 'Forecast',
    group: 'Virtual Pill Balance Management',
    order: 2,
  },
  {
    key: 'vpbUpdateBalance',
    label: 'Update Balance',
    group: 'Virtual Pill Balance Management',
    order: 3,
  },
];

export const DRUG_MANAGEMENT_ENUM = [
  {
    key: 'drugAddCustomDrug',
    label: 'Add Custom Drug',
    group: 'Drug Management',
    order: 1,
  },
  {
    key: 'drugEditDrug',
    label: 'Edit Drug',
    group: 'Drug Management',
    order: 2,
  },
  {
    key: 'drugDeleteDrug',
    label: 'Delete Drug',
    group: 'Drug Management',
    order: 3,
  },
  {
    key: 'drugAddBarcode',
    label: 'Add Barcode',
    group: 'Drug Management',
    order: 4,
  },
  {
    key: 'drugEditBarcode',
    label: 'Edit Barcode',
    group: 'Drug Management',
    order: 5,
  },
  {
    key: 'drugDeleteBarcode',
    label: 'Delete Barcode',
    group: 'Drug Management',
    order: 6,
  },
];

export const PATIENT_MANAGEMENT_ENUM = [
  {
    key: 'patientAddNewPatient',
    label: 'Add New Patient',
    group: 'Patient Management',
    order: 1,
  },
  {
    key: 'patientAddBlisterPack',
    label: 'Add Blister Pack',
    group: 'Patient Management',
    order: 2,
  },
  {
    key: 'patientEditPack',
    label: 'Edit Pack',
    group: 'Patient Management',
    order: 3,
  },
  {
    key: 'patientPrintPack',
    label: 'Print Pack',
    group: 'Patient Management',
    order: 4,
  },
  {
    key: 'patientDeletePack',
    label: 'Delete Pack',
    group: 'Patient Management',
    order: 5,
  },
  {
    key: 'patientPrintReport',
    label: 'Print Report',
    group: 'Patient Management',
    order: 6,
  },
  {
    key: 'patientPrintSigningSheets',
    label: 'Print Signing Sheets',
    group: 'Patient Management',
    order: 7,
  },
  {
    key: 'patientAddDrugs',
    label: 'Add Drugs',
    group: 'Patient Management',
    order: 8,
  },
  {
    key: 'patientEditDrug',
    label: 'Edit Drug',
    group: 'Patient Management',
    order: 9,
  },
  {
    key: 'patientCeaseDrug',
    label: 'Cease Drug',
    group: 'Patient Management',
    order: 10,
  },
  {
    key: 'patientDeleteDrug',
    label: 'Delete Drug',
    group: 'Patient Management',
    order: 11,
  },
  {
    key: 'patientEditPatientDetails',
    label: 'Edit Patient Details',
    group: 'Patient Management',
    order: 12,
  },
  {
    key: 'patientCommentsForChangeOfMedicationRequired',
    label: 'Comments for Change of Medication Required',
    group: 'Patient Management',
    order: 13,
  },
];

export const ROLE_MANAGEMENT_ENUM = [
  {
    key: 'roleAddRoles',
    label: 'Add Roles',
    group: 'Role Management',
    order: 1,
  },
  {
    key: 'roleEditRoles',
    label: 'Edit Roles',
    group: 'Role Management',
    order: 2,
  },
];

export const PRINT_OPTIONS_MANAGEMENT_ENUM = [
  {
    key: 'printOptionsEdit',
    label: 'Edit Print Options',
    group: 'Print Options Management',
    order: 1,
  },
];

export const ADMINISTRATOR_ID = 'pharmacy_administrator';

export const INIT_ENTRY_PERMISSIONS = {
  [MENU_ENUM.JOB]: JOB_MANAGERMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.USER]: USER_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.PHARMACY]: PHARMACY_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.DIRECTION]: DIRECTIONS_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.PATIENT_GROUP]: PATIENT_GROUP_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.DOCTOR]: DOCTOR_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.REPORT]: REPORT_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.DISPENSE_TRACKER]: DISPENSE_TRACKER_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.VPB]: VPB_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.DRUG]: DRUG_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.PATIENT]: PATIENT_MANAGEMENT_ENUM.map((i) => ({
    ...i,
    isAllowed: i.key !== 'patientCommentsForChangeOfMedicationRequired',
    code: i.key,
  })),
  [MENU_ENUM.ROLE]: ROLE_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
  [MENU_ENUM.PRINT_PROFILE]: PRINT_OPTIONS_MANAGEMENT_ENUM.map((i) => ({ ...i, isAllowed: true, code: i.key })),
};
